import { SceneBase } from '@jollywise/jollygoodgame';
export default class SceneBaseTT extends SceneBase {
  create() {
    super.create();
  }

  get centerX() {
    return this.game.defaultWidth * 0.5;
  }

  get centerY() {
    return this.game.defaultHeight * 0.5;
  }

  setBackgroundColour(colour = 0x145471) {
    this.cameras.main.setBackgroundColor(colour);
  }

  setBackgroundImage(sheet, frame) {
    this.children.sendToBack(
      this.add.image(this.game.defaultWidth * 0.5, this.game.defaultHeight * 0.5, sheet, frame)
    );
  }
}
